let activeDialog = null;
const sliders = new Map();

function initSliders(root = document) {
  root.querySelectorAll('[data-ingredient-slider]').forEach((slider) => {
    if (sliders.has(slider)) return;
    const track = slider.querySelector('[data-slider-track]');
    const cards = [...track.querySelectorAll('[data-card-index]')];
    const previous = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    const position = slider.querySelector('[data-slider-position]');
    const update = () => {
      const end = Math.max(0, track.scrollWidth - track.clientWidth);
      const left = Math.max(0, track.scrollLeft);
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = (cards[0]?.getBoundingClientRect().width || 0) + gap;
      const index = step ? Math.min(cards.length - 1, Math.round(left / step)) : 0;
      previous.disabled = left <= 1;
      next.disabled = left >= end - 1;
      const label = `${index + 1} / ${cards.length}`;
      if (position.textContent !== label) position.textContent = label;
      slider.querySelector('.slider-nav').hidden = end <= 1;
    };
    track.addEventListener('scroll', update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    sliders.set(slider, { observer, track, update });
    update();
  });
}

initSliders();
document.addEventListener('shopify:section:load', (event) => initSliders(event.target));
document.addEventListener('shopify:block:select', (event) => {
  const card = event.target.closest('[data-card-index]');
  const track = card?.closest('[data-slider-track]');
  if (track) track.scrollLeft += card.getBoundingClientRect().left - track.getBoundingClientRect().left;
});

function openDialog(dialog, opener) {
  if (!dialog || dialog.open || activeDialog) return;

  const previousOverflow = document.body.style.overflow;
  activeDialog = dialog;
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    activeDialog = null;
    if (opener.isConnected) opener.focus({ preventScroll: true });
  }, { once: true });
  dialog.showModal();
  document.body.style.overflow = 'hidden';
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-open-popup], .nutrition-info');
  if (opener) {
    const section = opener.closest('.ingredient-slider-section');
    if (!section) return;
    const selector = opener.matches('.nutrition-info')
      ? '[data-nutrition-popup]'
      : `[data-popup="${opener.dataset.openPopup}"]`;
    openDialog(section.querySelector(selector), opener);
    return;
  }

  const closer = event.target.closest('[data-popup-close], [data-nutrition-close]');
  if (closer) {
    const dialog = closer.closest('.ingredient-slider-section dialog');
    if (dialog) dialog.close();
    return;
  }

  if (event.target === activeDialog) {
    const bounds = activeDialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) {
      activeDialog.close();
    }
    return;
  }

  const arrow = event.target.closest('[data-slider-prev], [data-slider-next]');
  if (!arrow) return;
  const track = arrow.closest('[data-ingredient-slider]')?.querySelector('[data-slider-track]');
  if (!track) return;
  const card = track.querySelector('.card');
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
  track.scrollBy({
    left: arrow.hasAttribute('data-slider-prev') ? -step : step,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  });
});

document.addEventListener('keydown', (event) => {
  if (!activeDialog || event.key !== 'Tab' || !activeDialog.contains(event.target)) return;
  const controls = activeDialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]');
  const first = controls[0];
  const last = controls[controls.length - 1];
  if (event.shiftKey && event.target === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && event.target === last) {
    event.preventDefault();
    first.focus();
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  if (activeDialog && event.target.contains(activeDialog)) activeDialog.close();
  sliders.forEach(({ observer, track, update }, slider) => {
    if (!event.target.contains(slider)) return;
    observer.disconnect();
    track.removeEventListener('scroll', update);
    sliders.delete(slider);
  });
});
